<template>
  <div>
    <CRow class="content-fade-in" ref="container">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"
                             :listener="titleInput.listener"/>
                </CCol>

                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                v-model="descriptionInput.data.model"/>
                </CCol>

                <CCol sm="12" md="12" xl="12">
                  <div class="form-group form-row" :class="{
                                        'input-valid-error': selectedFiles.data.validator && !selectedFiles.data.validator.isValid,
                                        'no-label': !(selectedFiles.options && selectedFiles.options.label)
                                    }">
                    <label class="col-form-label" v-html="selectedFiles.options.label"></label>
                    <input type="text" :placeholder="selectedFiles.options.placeholder"
                           class="form-control col-sm-12 col-md-12 col-xl-12 " readonly
                           v-model="selectedFiles.data.title" @click="chooseFile()" ref="selectedFiles"/>
                    <div class="valid-error"
                         v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                      {{
                        selectedFiles.data.validator ?
                          selectedFiles.data.validator.errorMessage : ""
                      }}
                    </div>
                  </div>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="12" class="mt-4">

                  <div class="position-relative table-responsive">
                    <table class="table">
                      <thead>
                      <tr>
                        <th style="vertical-align: middle; overflow: hidden; width: 40%;">
                          <div>Tên</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 15%;">
                          <div>Lĩnh vực</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 10%;">
                          <div>Thời lượng / Kích thước</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 25%;">
                          <div>File</div>
                        </th>
                        <th style="vertical-align: middle; overflow: hidden; width: 10%;">
                          <div>Thao tác</div>
                        </th>
                      </tr>
                      </thead>
                      <tbody class="position-relative">
                      <draggable :list="selectedFiles.data.model" ghost-class="ghost"
                                 style="display: contents" group="people" :move="checkMoveLayer"
                                 @start="startDraggable" @end="endDraggable">
                        <template v-for="(each, index) in selectedFiles.data.model">
                          <tr>
                            <td>{{ each.title }}</td>
                            <td>{{ each.fileTypeName }}</td>
                            <td>{{ each.duration }} / {{ $helper.formatFileSize(each.size) }}</td>
                            <td>
                              <audio controls="controls" aria-label="Tệp chuyển đổi"
                                     class="audio-css" style="width: 80%;min-width: 300px;"
                                     ref="audio">
                                <source :src="each.url" type="audio/mpeg">
                                <source :src="each.url" type="audio/wav">
                              </audio>
                            </td>
                            <td>
                              <CButton color="danger" variant="outline" class="ml-1"
                                       square size="sm" @click="deleteFile(index)"
                                       v-c-tooltip.hover="'Xóa'">
                                <i class="fa fa-trash"
                                   style="font-size: 15px!important;"></i>
                              </CButton>
                            </td>
                          </tr>
                        </template>
                      </draggable>
                      <tr v-if="selectedFiles.data.model.length > 0">
                        <td colspan="4">
                          Kích thước tổng
                        </td>
                        <td>
                          <span style="font-weight: bold; font-size: 20px;"> {{ $helper.formatFileSize(selectedFiles.data.totalSize) }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol sm="6" md="6">
                  <CButton color="primary" class="btn-action-primary mr-2" @click="submitData">
                    <i class="fa fa-save"></i>&nbsp;Lưu lại
                  </CButton>
                  <CButton color="secondary" class="btn-action-primary mr-2" @click="resetData()"><i
                    class="fa fa-eraser"></i>&nbsp;Làm mới
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="$router.go(-1)"><i
                    class="fa fa-reply"></i>&nbsp;Hủy bỏ
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <BaseLoading :loading="loading.value"></BaseLoading>
    </CRow>

    <FileManagementChooseMany v-if="chooseFileData.isShowModal" @file:selected="chooseFileSelected($event)"
                              @close-modal="closeModalChooseFile($event)">
    </FileManagementChooseMany>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import BaseAudioAddFile from "@/views/base/BaseAddFile";
import draggable from 'vuedraggable';
import FileManagementChooseMany from "@/views/base/FileManagementChooseMany";
import BaseTextArea from "@/views/base/BaseTextArea";
import {PLAYLIST_MAX_SIZE} from "@/constant";

export default {
  name: "PlayListAdd",
  components: {BaseAudioAddFile, BaseSelect, BaseInput, BaseLoading, draggable, FileManagementChooseMany, BaseTextArea},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},

      selectedFiles: {
        options: {
          label: "Tệp tin <span class='required'>*</span> ",
          placeholder: 'Chọn tệp tin ...'
        },
        data: {
          title: "",
          name: "lstDetail",
          model: [],
          totalSize: 0,
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model;
              let totalSize = that.selectedFiles.data.totalSize;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "File không được để trống";
              } else if (value.length == 1) {
                this.isValid = false;
                this.errorMessage = "Tối thiểu phải 2 file";
              } else if (totalSize >= PLAYLIST_MAX_SIZE) {
                this.isValid = false;
                this.errorMessage = "Danh sách phát không vượt quá " + that.$helper.formatFileSize(PLAYLIST_MAX_SIZE);
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },

      chooseFileData: {
        isShowModal: false
      },
      titleInput: {
        options: {
          label: "Tên danh sách phát <span class='required'>*</span>",
          placeholder: "Tên danh sách phát",
          type: "text"
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên danh sách phát không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },

      descriptionInput: {
        options: {
          label: "Mô tả danh sách phát",
          placeholder: "Mô tả danh sách phát",
          maxlength: 512,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      chooseFileTable: {
        options: {
          fields: [
            {key: "title", label: "Tên", _style: 'width: 40%;'},
            {key: "url", label: "File", _style: 'width: 30%;'},
            {key: "duration", label: "Thời lượng", _style: 'width: 10%;'},
            {key: "action", label: "Thao tác", _style: 'width: 10%;'}
          ],
          slots: ["index", "name", "size", "url", "action"],
        },
      },
      fileRequest: []
    };
  },
  methods: {
    calculateTotalSizeFile() {
      let totalSize = 0;
      this.selectedFiles.data.model.forEach(each => {
        totalSize += each.size;
      })
      this.selectedFiles.data.totalSize = totalSize;
      this.selectedFiles.data.validator.valid();
    },
    chooseFileSelected(value) {
      value.some(obj2 => {
        if (!this.selectedFiles.data.model.some(obj1 => obj1.id === obj2.id)) {
          this.selectedFiles.data.model.push(obj2)
        }
      });
      this.chooseFileData.isShowModal = false;
      this.calculateTotalSizeFile();
    },
    closeModalChooseFile() {
      this.chooseFileData.isShowModal = false;
    },
    chooseFile() {
      this.chooseFileData.isShowModal = true;
    },
    changeIndexFile(index, type) {
      this.loading.value = true;
      if (type == 'up') {
        this.arrayMove(index, index - 1);
      } else if (type == 'down') {
        this.arrayMove(index, index + 1);
      }
    },
    async deleteFile(index) {
      let that = this;
      this.loading.value = true;
      this.selectedFiles.data.model.splice(index, 1);
      this.fileRequest.splice(index, 1);
      this.calculateTotalSizeFile();
      setTimeout(() => {
        this.reloadAudio(that.selectedFiles.data.model).then(result => {
          that.loading.value = false;
        });
      }, 100)
    },
    async reloadAudio(files) {
      let that = this;
      const promise = await new Promise((resolve) => {
        if (that.$refs.audio && that.$refs.audio.length > 0) {
          that.$refs.audio.map(each => each.load());
          // files.map(each => that.$refs[each.urlBlob].load());
          resolve(files)
        }
      })
      return promise;
    },
    async arrayMove(old_index, new_index) {
      let data = [this.selectedFiles.data.model, this.fileRequest];
      Promise.all(
        (function* () {
          for (let each of data) {
            yield new Promise(resolve => {
              if (new_index >= each.length) {
                let k = new_index - each.length + 1;
                while (k--) {
                  each.push(undefined);
                }
              }
              each.splice(new_index, 0, each.splice(old_index, 1)[0]);
              resolve(each)
            })
          }
        })())
        .then(() => {
          this.reloadAudio(this.selectedFiles.data.model)
          setTimeout(() => {
            this.loading.value = false;
          }, 100)
        }).catch(error => {
        // console.log(error);
      })
    },
    resetData() {
      this.titleInput.data.model = '';
      this.selectedFiles.data.model = [];
      this.descriptionInput.data.model = '';
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      if (!isValid) {
        return;
      }
      this.loading.value = true;

      var lstDetail = [];

      for (var i = 0; i < this.selectedFiles.data.model.length; i++) {
        lstDetail.push({
          id: this.selectedFiles.data.model[i].id //file id
        });
      }

      var title = this.titleInput.data.model;

      var description = this.descriptionInput.data.model;

      that.$helper.loadDataSource({
        url: "/play-list/add",
        dataSubmit: function () {
          return {
            name: title,
            lstDetail: lstDetail,
            description: description
          };
        },
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Thêm danh sách phát thành công"});
            that.$router.go(-1);
          }
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    loadingAdd(value) {
      if (value) {
        this.loading.value = true;
      } else {
        this.loading.value = false;
      }
    },
    checkMoveLayer(e) {
    },
    startDraggable(event) {
    },
    endDraggable(event) {
      this.array_move(this.fileRequest, event.oldIndex, event.newIndex)
    },
    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    }

  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    'selectedFiles.data.model': function () {
      let that = this;
      this.reloadAudio(that.selectedFiles.data.model).then(result => {
        that.loading.value = false;
      });
    }
  }
};
</script>


<style lang="scss">
.modal-chooseFile {

  .modal-dialog {
    height: 90vh;

    .modal-content {
      height: 100%;

      .modal-body {
        height: 100%;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 4px;
          height: 4px;
          background-color: rgba(127, 127, 127, .2) !important;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #39a2ff !important;
        }

        &::-webkit-scrollbar-track {
          --webkit-box-shadow: inset 0 0 6px rgba(127, 127, 127, .2);
          background-color: white !important
        }
      }
    }
  }
}
</style>
